export default "__VITE_ASSET__979380f5__"